// TermsOfService.js
import React, { useEffect } from 'react';

function TermsOfService() {

  useEffect(() => {
    document.title = 'Terms of use';
  }, []);


  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <h1 className="privacy-title">Nvoice: Terms of use</h1>
      </header>
      <div className="privacy-body">
        <p className="paragraph">These Terms of Use are a binding contract between you and Nvoice Ltd. 
        (“we”, “us”, “our”). It contains the rules and restrictions that govern your use of Nvoice’s 
        products and services (referred to below simply as “Nvoice”). If you have any questions, 
        comments, or concerns regarding these Terms or our products and services, please contact us 
        at support@metaspringai.com.</p>
        <p className="paragraph">Using Nvoice in any way means that you agree to all of these Terms, 
        and these Terms will remain in effect while you use Nvoice. These Terms include everything in 
        this document, as well as those in the Privacy Policy.</p>
        <p className="paragraph">You represent and warrant that you are of legal age to form a binding 
        contract (or if not, that you’ve received your parent’s or guardian’s permission to use Nvoice 
        and that your parent or guardian agrees to these Terms on your behalf).</p>

        <h2 className="section-title">Content on Nvoice</h2>
        <p className="paragraph">You own what you create. Any original content you post, upload, share, store, 
        or otherwise provide to Nvoice remains yours and is protected by copyright and any other applicable 
        intellectual property laws. We reserve the right to remove any content from Nvoice at any time, 
        for any reason (including, but not limited to, if someone alleges you contributed that content in 
        violation of these Terms), in our sole discretion, and without notice.</p>
        <h2 className="section-title">Acceptable Use Policy</h2>
        <p className="paragraph">You are responsible for all your activity in connection with Nvoice. 
        Make sure that you use Nvoice in a manner that complies with the law. If your use of Nvoice is 
        prohibited by applicable laws, then you aren’t authorized to use Nvoice. We can’t and won’t be 
        responsible for you using Nvoice in a way that breaks the law.</p>
        <p className="paragraph">You also agree that you will not use Nvoice in a manner that:</p>
        <ul className="list">
          <li className="list-item">Is fraudulent or threatening.</li>
          <li className="list-item">Jeopardizes the security of your Nvoice account or anyone else’s 
          (such as allowing someone else to log into Nvoice as you, or sharing your account or password with someone).</li>
          <li className="list-item">Attempts, in any manner, to obtain the password, account, or other security 
          information of any other user.</li>
          <li className="list-item">Violates the security of any computer network, or cracks any passwords or 
          security encryption codes.</li>
          <li className="list-item">Decompiles, reverse engineers, or otherwise attempts to obtain the source 
          code or underlying ideas or information of or relating to Nvoice.</li>
          
        </ul>
        <h2 className="section-title">Limitation of Liability</h2>
        <p className="paragraph">To the fullest extent allowed by applicable law, under no circumstances and under no legal 
        theory shall Nvoice, its licensors, or its suppliers be liable to you or to any other person for any indirect, 
        special, incidental, or consequential damages of any kind, or any amount, in the aggregate, in excess of the greater 
        of (1) $100 or (2) the amounts paid and/or payable by you to us in connection with Nvoice in the twelve-month 
        period preceding the applicable claim.</p>
        <h2 className="section-title">Terminating Your Account</h2>
        
        <p className="paragraph">Nvoice is free to terminate (or suspend access to) your use of Nvoice, 
        or your account, for any reason at our discretion. We will try to provide advance notice to you prior 
        to our terminating your account so that you are able to retrieve any important Posts you may have uploaded 
        to your account, but we may not do so if we determine it would be impractical, illegal, not in the interest 
        of someone’s safety or security, or otherwise harmful to the rights or property of Nvoice.</p>
       

        {/* ... and so on */}
      </div>
    </div>
  );
};

export default TermsOfService;